export const createNewLabelHierarchy = (
  labelsHierarchy,
  groupName,
  labelId,
  parentId,
  subLabelIds,
) => {
  console.log(
    "createNewLabelHierarchy FROM:",
    labelsHierarchy,
    groupName,
    labelId,
    parentId,
    subLabelIds,
  );

  if (!groupName || !labelId) {
    console.error("Invalid: ", groupName, labelId);
    return null;
  } // Handling invalid inputs

  // If labelsHierarchy is null or undefined, create an empty hierarchy
  if (!labelsHierarchy) {
    return {
      groups: [
        {
          groupName: groupName,
          labels: [{ id: labelId }],
        },
      ],
    };
  }

  // Check if the group exists
  const existingGroup = labelsHierarchy.groups?.find(
    (g) => g.groupName === groupName,
  );

  if (!existingGroup) {
    const newGroups =
      labelsHierarchy?.groups?.length > 0
        ? [
            ...labelsHierarchy.groups,
            {
              groupName,
              labels: [
                {
                  id: labelId,
                  subLabels: subLabelIds?.length > 0 ? subLabelIds : [],
                },
              ],
            },
          ]
        : [{ groupName, labels: [{ id: labelId }] }];
    return { ...labelsHierarchy, groups: newGroups };
  }

  // If the group exists, add the label to it
  console.log("Existing group found: ", existingGroup);
  const updatedHierarchyGroups = labelsHierarchy.groups.map((g) => {
    if (g.groupName === groupName) {
      let updatedLabels = [...g.labels];

      if (parentId) {
        const parentLabel = updatedLabels.find((label) => label.id === parentId);
        if (parentLabel) {
          parentLabel.subLabels = [...(parentLabel.subLabels || []), labelId];
          return { ...g, labels: updatedLabels }; // Exit early, the label is added as a subLabel
        }
      }
      // No parentId, or parentLabel not found. Add the label normally.
      updatedLabels.push({
        id: labelId,
        subLabels: subLabelIds?.length > 0 ? subLabelIds : [],
      });
      return { ...g, labels: updatedLabels };
    }
    return g;
  });
  return { ...labelsHierarchy, groups: updatedHierarchyGroups };
};

export const removeLabelHierarchy = (labelsHierarchy, labelId) => {
  if (!labelsHierarchy) {
    return null;
  }

  const removeLabelFromArr = (labels) => {
    return labels
      .map((label) => {
        // Remove from subLabels if present
        if (label.subLabels) {
          label.subLabels = label.subLabels.filter((id) => id !== labelId);
        }
        return label;
      })
      .filter((label) => label.id !== labelId);
  };

  const updatedGroups = labelsHierarchy.groups.map((g) => {
    const updatedLabels = removeLabelFromArr(g.labels);
    return { ...g, labels: updatedLabels };
  });

  const nonEmptyGroups = updatedGroups.filter((g) => g.labels.length > 0);

  return { ...labelsHierarchy, groups: nonEmptyGroups };
};

export const findIfSubLabelInHierarchy = (labelsHierarchy, labelId) => {
  if (!labelsHierarchy) {
    return null;
  }

  // Flatten all groups' labels into a single array
  const allLabels = (labelsHierarchy.groups || [])
    .map((group) => group.labels)
    .flat();

  // Check if the label appears in any subLabels array
  const labelsWithThisAsSubLabel = allLabels.filter((label) => {
    return label.subLabels?.includes(labelId);
  });

  const isASubLabel = labelsWithThisAsSubLabel.length > 0;

  return isASubLabel;
};

export const findLabelsGroupInHierarchy = (labelsHierarchy, labelId) => {
  if (!labelsHierarchy) {
    return null;
  }

  const group = (labelsHierarchy.groups || []).find((g) => {
    return g.labels.find((l) => l.id === labelId);
  });

  return group;
};

/**
 * Find the parent label ID for a given sub-label
 * @param {Object} labelsHierarchy - The labels hierarchy
 * @param {string} labelId - The label ID to find the parent for
 * @returns {string|null} - The parent label ID or null if not found
 */
export const findParentLabelInHierarchy = (labelsHierarchy, labelId) => {
  if (!labelsHierarchy) {
    return null;
  }

  const allLabels = (labelsHierarchy.groups || [])
    .map((group) => group.labels)
    .flat();

  const parentLabel = allLabels.find((label) => {
    return label.subLabels?.includes(labelId);
  });

  return parentLabel?.id || null;
};
